import classNames from 'classnames'
import { APP_NAME } from '@/constants/app.constant'
import type { CommonProps } from '@/@types/common'

interface LogoProps extends CommonProps {
    type?: 'full' | 'streamline'
    mode?: 'light' | 'dark'
    imgClass?: string
    logoWidth?: number | string
}

const LOGO_SRC_PATH = '/img/logo/'

const Logo = (props: LogoProps) => {
    const {
        type = 'full',
        mode = 'light',
        className,
        imgClass,
        style,
        logoWidth = 'auto',
    } = props

    return (
        <div
            className={classNames(
                'logo flex items-center gap-3 min-w-0 overflow-hidden',
                className,
            )}
            style={{
                ...style,
                ...{ width: logoWidth },
            }}
        >
            <img
                alt={`${APP_NAME} logo`}
                className="header-logo shrink-0"
                src="/portal/img/logo/logo.png"
            />
            <span className="logo-text text-white min-w-0">
                <strong>OASYS</strong>
                <small>Employee portal</small>
            </span>
            {/* <img
                className={imgClass}
                src={`${LOGO_SRC_PATH}logo-${mode}-${type}.png`}
                alt={`${APP_NAME} logo`}
            /> */}
        </div>
    )
}

export default Logo
